var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoublePrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2803 6.46967C11.5732 6.76256 11.5732 7.23744 11.2803 7.53033L6.81066 12L11.2803 16.4697C11.5732 16.7626 11.5732 17.2374 11.2803 17.5303C10.9874 17.8232 10.5126 17.8232 10.2197 17.5303L5.21967 12.5303C4.92678 12.2374 4.92678 11.7626 5.21967 11.4697L10.2197 6.46967C10.5126 6.17678 10.9874 6.17678 11.2803 6.46967Z",
    fill: "#282A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2803 6.46967C18.5732 6.76256 18.5732 7.23744 18.2803 7.53033L13.8107 12L18.2803 16.4697C18.5732 16.7626 18.5732 17.2374 18.2803 17.5303C17.9874 17.8232 17.5126 17.8232 17.2197 17.5303L12.2197 12.5303C11.9268 12.2374 11.9268 11.7626 12.2197 11.4697L17.2197 6.46967C17.5126 6.17678 17.9874 6.17678 18.2803 6.46967Z",
    fill: "#282A2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublePrev);
export default __webpack_public_path__ + "static/media/Double-Prev.8569b10955974d69a0e9bc21bc6686a5.svg";
export { ForwardRef as ReactComponent };